import pdfService from "@services/pdfService";
import { createAction } from "@utils/storeUtils";
const fetchPdfJobs = createAction("FETCH_PDF_JOBS");
const fetchPdfJobsSuccess = createAction("FETCH_PDF_JOBS_SUCCESS");
const fetchPdfJobsFail = createAction("FETCH_PDF_JOBS_FAIL");
const fetchSinglePdfJob = createAction("FETCH_SINGLE_PDF_JOB");
const fetchSinglePdfJobSuccess = createAction("FETCH_SINGLE_PDF_JOB_SUCCESS");
const fetchSinglePdfJobFail = createAction("FETCH_SINGLE_PDF_JOB_FAIL");
const fetchInputFilesForJob = createAction("FETCH_INPUT_FILES_FOR_JOB");
const fetchInputFilesForJobSuccess = createAction("FETCH_INPUT_FILES_FOR_JOB_SUCCESS");
const fetchInputFilesForJobFail = createAction("FETCH_INPUT_FILES_FOR_JOB_FAIL");
const fetchOutputFilesForJob = createAction("FETCH_OUTPUT_FILES_FOR_JOB");
const fetchOutputFilesForJobSuccess = createAction("FETCH_OUTPUT_FILES_FOR_JOB_SUCCESS");
const fetchOutputFilesForJobFail = createAction("FETCH_OUTPUT_FILES_FOR_JOB_FAIL");
const filesUpload = createAction("FILES_UPLOAD");
const filesUploadSuccess = createAction("FILES_UPLOAD_SUCCESS");
const filesUploadFail = createAction("FILES_UPLOAD_FAIL");
export const clearUploadStatus = createAction("CLEAR_FILES_UPLOAD_STATUS");
export const addFilter = createAction("ADD_FILTER");
export const removeFilter = createAction("REMOVE_FILTER");
export const setFilters = createAction("SET_FILTERS");
export const changeOrderingDirection = createAction("CHANGE_ORDERING_DIRECTION");
export const changeOrderingKey = createAction("CHANGE_ORDERING_KEY");
export const setOrdering = createAction("SET_ORDERING");
export const loadPdfJobs = (params) => (dispatch) => {
    dispatch(fetchPdfJobs(params));
    return pdfService
        .loadPdfJobs(params)
        .then(({ data }) => dispatch(fetchPdfJobsSuccess(data)))
        .catch(({ error }) => dispatch(fetchPdfJobsFail(error)));
};
export const loadSinglePdfJob = (params) => (dispatch) => {
    dispatch(fetchSinglePdfJob(params));
    return pdfService
        .loadSinglePdfJob(params.jobId)
        .then(({ data }) => {
        dispatch(fetchSinglePdfJobSuccess(data));
        return data;
    })
        .catch(({ error }) => {
        dispatch(fetchSinglePdfJobFail(error));
        throw error;
    });
};
export const loadInputFilesForJob = (params) => (dispatch) => {
    dispatch(fetchInputFilesForJob(params));
    return pdfService
        .loadInputFilesForJob(params.jobId)
        .then(({ data }) => {
        dispatch(fetchInputFilesForJobSuccess(data));
        return data;
    })
        .catch(({ error }) => dispatch(fetchInputFilesForJobFail(error)));
};
export const loadOutputFilesForJob = (params) => (dispatch) => {
    dispatch(fetchOutputFilesForJob(params));
    return pdfService
        .loadOutputFilesForJob(params.jobId)
        .then(({ data }) => {
        dispatch(fetchOutputFilesForJobSuccess(data));
        return data;
    })
        .catch(({ error }) => dispatch(fetchOutputFilesForJobFail(error)));
};
export const uploadFiles = (params) => (dispatch) => {
    dispatch(filesUpload(params));
    return pdfService
        .uploadFiles(params)
        .then(({ data }) => dispatch(filesUploadSuccess(data)))
        .catch(error => {
        dispatch(filesUploadFail({
            message: error.response.data.title
        }));
    });
};
